exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.branding[data-v-6e9406a6] {\n    padding: 20px 0;\n    text-align: center;\n}\n.branding img[data-v-6e9406a6] {\n    max-width: 100%;\n}\n.title[data-v-6e9406a6] {\n    text-align: center;\n    margin: 0 0 10px 0;\n    font-size: 24px;\n    font-weight: 700;\n}\n.description[data-v-6e9406a6] {\n    text-align: center;\n}\n.top[data-v-6e9406a6] {\n    margin-bottom: 30px;\n    background: #fff;\n    border-bottom: solid 2px;\n}\n", ""]);

// exports
